var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDebit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#1E6EFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9375 13C7.9375 11.0325 9.4616 9.4375 11.3417 9.4375H20.6583C22.5384 9.4375 24.0625 11.0325 24.0625 13L24.0625 13.9375H7.9375V13ZM7.9375 15.0625H24.0625L24.0625 19C24.0625 19.35 24.0143 19.6881 23.9244 20.0076C23.7913 19.9622 23.6485 19.9375 23.5 19.9375H20.9362C21.1673 19.4502 21.0812 18.8501 20.6781 18.4469C20.1655 17.9344 19.3345 17.9344 18.8219 18.4469L16.9469 20.3219C16.4344 20.8345 16.4344 21.6655 16.9469 22.1781L17.3313 22.5625H11.3417C9.4616 22.5625 7.9375 20.9675 7.9375 19V15.0625Z",
    fill: "#0066FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1477 18.9773C19.9281 18.7576 19.5719 18.7576 19.3523 18.9773L17.4773 20.8523C17.2576 21.0719 17.2576 21.4281 17.4773 21.6477L19.3523 23.5227C19.5719 23.7424 19.9281 23.7424 20.1477 23.5227C20.3674 23.3031 20.3674 22.9469 20.1477 22.7273L19.233 21.8125H23.5C23.8107 21.8125 24.0625 21.5607 24.0625 21.25C24.0625 20.9393 23.8107 20.6875 23.5 20.6875H19.233L20.1477 19.7727C20.3674 19.5531 20.3674 19.1969 20.1477 18.9773Z",
    fill: "#1E6EFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebit);
export default __webpack_public_path__ + "static/media/debit.7cc91a7c5b2f0d1eb61591f98e59ac95.svg";
export { ForwardRef as ReactComponent };